import { registerComponent, createMessage } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "registry-added-confirmation",
  class RegistryAddedConfirmation extends WYATTElement {
    constructor() {
      super();

      this.giftReggieSettings = this.getGiftReggieSettings();

      if (!this.giftReggieSettings) {
        console.warn("Unable to fetch Gift Reggie settings");
        return;
      }

      this.watchRegistryButtonText();
    }

    onPending() {
      // no-op
    }

    onSuccess() {
      createMessage(
        `${WYATT.t.addToRegistry.addSuccess}. <a href="/apps/giftregistry/registry/${WYATT.shopify.customer.registryID}">${WYATT.t.addToRegistry.goToRegistry}</a>.`,
        { type: "success" },
      );

      this.pushAddToRegistry();
    }

    pushAddToRegistry() {
      if (this.addTracked) return;
      this.addTracked = true;

      const { pathname, href } = window.location;
      const match = pathname.match(/\/products\/([^/?]+)/);
      const handle = match ? match[1] : "unknown";
      const products = WYATT.shopify && WYATT.shopify.product;
      const product = products && products[handle] ? products[handle] : null;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_registry",
        registry_id: WYATT.shopify.customer.registryID,
        product_handle: handle,
        product_id: product ? product.id : undefined,
        product_title: product ? product.title : undefined,
        page_location: href,
      });
    }

    getGiftReggieSettings() {
      try {
        return JSON.parse(
          document.getElementById("gift_reggie_data").textContent,
        );
      } catch {
        return null;
      }
    }

    watchRegistryButtonText() {
      const button = this.querySelector(".giftreggie-pdp-registry-cta");

      if (!button) {
        return;
      }

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type !== "childList") {
            return;
          }

          if (
            button.textContent === this.giftReggieSettings.i18n.registry.pending
          ) {
            this.onPending();
          }

          if (
            button.textContent ===
            this.giftReggieSettings.i18n.registry.successAdd
          ) {
            this.onSuccess();
          }
        });
      });

      observer.observe(button, { childList: true });
    }
  },
);
